import I18n from 'app/i18n';

export const checkOwnLine = (isCreator: boolean): string => {
    if (isCreator) {
        return I18n.t('bet_own_lines');
    }
    return null;
};
